"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M2.35547 16.7383C4.39453 18.7773 7.69922 18.7773 9.73828 16.7383C11.6367 14.8398 14.7305 11.7461 16.6289 9.84766C16.8047 9.67188 16.8047 9.42578 16.6289 9.25L16.0312 8.65234C15.8555 8.47656 15.6094 8.47656 15.4336 8.65234C13.5352 10.5508 10.4414 13.6445 8.54297 15.543C7.17188 16.9141 4.92188 16.9141 3.55078 15.543C2.17969 14.1719 2.17969 11.9219 3.55078 10.5508L11.4609 2.64062C12.375 1.72656 13.8516 1.72656 14.7656 2.64062C15.6797 3.55469 15.6797 5.03125 14.7656 5.94531L8.12109 12.5898C7.66406 13.0469 6.92578 13.0469 6.46875 12.5898C6.04688 12.168 6.04688 11.4297 6.46875 10.9727L12.1289 5.34766C12.3047 5.17188 12.3047 4.92578 12.1289 4.75L11.5312 4.15234C11.3555 3.97656 11.1094 3.97656 10.9336 4.15234L5.30859 9.77734C4.18359 10.9023 4.18359 12.6953 5.30859 13.7852C6.39844 14.9102 8.19141 14.9102 9.28125 13.7852L15.9609 7.14062C17.543 5.55859 17.543 3.02734 15.9609 1.44531C14.3789 -0.136719 11.8477 -0.136719 10.2656 1.44531L2.35547 9.35547C0.316406 11.3945 0.316406 14.6992 2.35547 16.7383Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;